import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import { useGallery } from "../context/GalleryContext";
import SectionLabel from "../components/SectionLabel";
import { artImage } from "../utils/image";
import { tokens } from "../theme";

const ArrowForward = () => <Box component="span">→</Box>;

export default function Collections() {
  const { artworks, collections } = useGallery();

  return (
    <Container maxWidth="lg" sx={{ pt: { xs: 5, md: 8 } }}>
      <SectionLabel>Browse by theme</SectionLabel>
      <Typography
        variant="h1"
        sx={{ mt: 2, fontSize: { xs: "2.8rem", md: "4rem" } }}
      >
        Collections
      </Typography>

      <Box
        sx={{
          mt: { xs: 5, md: 8 },
          display: "flex",
          flexDirection: "column",
          gap: { xs: 6, md: 9 },
        }}
      >
        {collections.map((c, i) => {
          const pieces = artworks.filter((a) => a.collectionId === c.id);
          const cover =
            artworks.find((a) => a.id === c.coverArtId) ?? pieces[0];
          const reversed = i % 2 === 1;
          return (
            <Box
              key={c.id}
              component={RouterLink}
              to={`/collections/${c.id}`}
              sx={{
                textDecoration: "none",
                color: "inherit",
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: { xs: 3, md: 7 },
                alignItems: "center",
                "&:hover img": { transform: "scale(1.04)" },
                "&:hover .tl-arrow": { transform: "translateX(6px)" },
              }}
            >
              <Box
                sx={{
                  order: { md: reversed ? 2 : 1 },
                  overflow: "hidden",
                  aspectRatio: "5 / 4",
                  bgcolor: tokens.paper,
                  border: `1px solid ${tokens.line}`,
                }}
              >
                {cover && (
                  <Box
                    component="img"
                    src={artImage(cover)}
                    alt={c.name}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 800ms cubic-bezier(.2,.7,.2,1)",
                    }}
                  />
                )}
              </Box>
              <Box sx={{ order: { md: reversed ? 1 : 2 } }}>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 700,
                    letterSpacing: "0.2em",
                    textTransform: "uppercase",
                    color: tokens.brass,
                  }}
                >
                  {String(i + 1).padStart(2, "0")} / {pieces.length}{" "}
                  {pieces.length === 1 ? "piece" : "pieces"}
                </Typography>
                <Typography
                  variant="h2"
                  sx={{ mt: 1.5, fontSize: { xs: "2.2rem", md: "3rem" } }}
                >
                  {c.name}
                </Typography>
                {c.description && (
                  <Typography sx={{ mt: 2, maxWidth: 460 }}>
                    {c.description}
                  </Typography>
                )}
                <Box
                  sx={{
                    mt: 3,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    color: tokens.ink,
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                  }}
                >
                  View collection{" "}
                  <ArrowForward
                    className="tl-arrow"
                    sx={{ fontSize: 18, transition: "transform 220ms ease" }}
                  />
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Container>
  );
}
